import styled from 'styled-components';

const percentageSize = 1.3;
export const IconoCorreo = () => {
  return (
    <svg id="Layer_3" height="25" viewBox="0 0 32 32" width="25" xmlns="http://www.w3.org/2000/svg" data-name="Layer 3">
      <path
        d="m31.348 13.8a15.5 15.5 0 0 0 -30.721 4.215 15.614 15.614 0 0 0 13.31 13.351 16.058 16.058 0 0 0 2.08.136 15.351 15.351 0 0 0 7.972-2.217 1.5 1.5 0 0 0 -1.548-2.57 12.5 12.5 0 1 1 -4.789-23.109 12.5 12.5 0 0 1 10.162 16.488 2.166 2.166 0 0 1 -2.079 1.406 2.238 2.238 0 0 1 -2.235-2.235v-9.265a1.5 1.5 0 0 0 -3 0v.014a7.5 7.5 0 1 0 .541 11.523 5.224 5.224 0 0 0 4.694 2.963 5.167 5.167 0 0 0 4.914-3.424 15.535 15.535 0 0 0 .699-7.276zm-15.348 6.7a4.5 4.5 0 1 1 4.5-4.5 4.505 4.505 0 0 1 -4.5 4.5z"
        fill="white"
      />
    </svg>
  );
};

export const IconoAlerta = () => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" height="25" width="25" viewBox="0 0 485.811 485.811">
      <g>
        <path
          d="M476.099,353.968l-170.2-294.8c-27.8-48.7-98.1-48.7-125.8,0l-170.3,294.8c-27.8,48.7,6.8,109.2,62.9,109.2h339.9
                C468.699,463.168,503.899,402.068,476.099,353.968z M242.899,397.768c-14.8,0-27.1-12.3-27.1-27.1s12.3-27.1,27.1-27.1
                c14.8,0,27.1,12.3,26.5,27.8C270.099,385.468,257.099,397.768,242.899,397.768z M267.599,222.568c-1.2,21-2.5,41.9-3.7,62.9
                c-0.6,6.8-0.6,13-0.6,19.7c-0.6,11.1-9.3,19.7-20.4,19.7s-19.7-8-20.4-19.1c-1.8-32.7-3.7-64.8-5.5-97.5
                c-0.6-8.6-1.2-17.3-1.9-25.9c0-14.2,8-25.9,21-29.6c13-3.1,25.9,3.1,31.5,15.4c1.9,4.3,2.5,8.6,2.5,13.6
                C269.499,195.468,268.199,209.068,267.599,222.568z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const CorreoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  justify-content: center;
  gap: 15px;
  padding: 20px;
`;

export const TextCorreo = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  height: fit-content; //CAMBIAR
  width: fit-content; //CAMBIAR
  @media screen and (max-width: 1600px) {
    overflow-y: scroll;
    height: 230px;
    width: 99%;
    ::-webkit-scrollbar {
      width: 7px;
      border-radius: 5px;
    }

    ::-webkit-scrollbar-track {
      background: #333333;
      border-radius: 5px;
    }

    ::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 5px;
    }
  }
`;

export const TextCorreoLink = styled.a.attrs({ target: '_blank' })`
  color: #febf00;
  &:hover {
    opacity: 0.7;
    color: #febf00;
  }
`;

export const TextCorreoAlerta = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;

export const Correo = styled.div`
  display: flex;
  gap: 5px;
  border-bottom: 0.5px solid white;
  height: 30px;
  width: 100%;
  margin-bottom: 30px;
  @media screen and (max-width: 1600px) {
    width: 95%;
  }
`;

export const InputCorreo = styled.input`
  background: transparent;
  color: white;
  width: 100%;
  border: none;
  outline: none;
  &::placeholder {
    color: #aaaaaa;
  }
`;

export const ButtonCorreo = styled.button`
  border: none;
  height: 32px;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  padding: 2px 5px;
  color: white;
  width: 100%;
  height: 40px;
  background-color: gray;
  border-radius: 5px;
  ${(props) => props.disabled && 'opacity: 0.6; cursor: not-allowed;'}
`;

export const FormCorreo = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ConsentimentDades = styled.div`
  //padding: 3px;
  //padding-top: 3px;
  display: flex;
  gap: 15px;
  font-size: 13px;
  justify-content: center;
  align-items: normal;
`;

export const CheckboxConsentiment = styled.input.attrs({ type: 'checkbox' })`
  opacity: 90%;
  appearance: none;
  font: inherit;
  color: white;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 22 * percentageSize : 22)}px;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 18 * percentageSize : 18)}px;
  margin-right: 3px;
  margin-top: 5px;
  border: ${({ checked }) => (checked ? '0.18em solid #febf00' : '0.18em solid white')};
  border-radius: 0.15em;
  display: grid;
  place-content: center;
  display: inline-block;
  position: relative;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
  :checked {
    position: relative;
    width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 22 * percentageSize : 22)}px;
    height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 18 * percentageSize : 18)}px;
    background-image: url(${({ img }) => img});
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 0.15em;
    transition: 0.3s;
  }
`;

// export const LayerCheckbox = styled.input`
//   opacity: 90%;
//   appearance: none;
//   font: inherit;
//   color: white;
//   width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
//   height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
//   margin-right: 3px;
//   margin-top: 5px;
//   border: ${({ checked }) => (checked ? '0.13em solid #febf00' : '0.13em solid white')};
//   border-radius: 0.15em;
//   display: grid;
//   place-content: center;
//   display: inline-block;
//   position: relative;

//   :hover {
//     box-shadow: 0 0px 7px #febf00dd;
//   }

//   :checked {
//     position: relative;
//     width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
//     height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
//     background-image: url(${({ img }) => img});
//     background-repeat: no-repeat;
//     background-size: contain;
//     border-radius: 0.15em;
//     transition: 0.3s;
//   }
// `;
